import type { Locale } from './types';

export function formatEuro(cents: number, locale: Locale = 'de'): string {
  return new Intl.NumberFormat(locale === 'de' ? 'de-AT' : 'en-GB', {
    style: 'currency',
    currency: 'EUR',
  }).format(cents / 100);
}

/** Betrag als Text für Formulare, z. B. 1250 → "12,50". */
export function centsToInput(cents: number): string {
  return (cents / 100).toFixed(2).replace('.', ',');
}

/** "12,50" oder "12.5" → 1250. Gibt `null` bei ungültiger Eingabe zurück. */
export function inputToCents(value: string): number | null {
  const normalized = value.trim().replace(/\s/g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(normalized)) {
    return null;
  }
  return Math.round(Number(normalized) * 100);
}
